/*
 * combines all th existing reducers
 */
import * as loadingReducer from './loadingReducer';
import * as loginReducer from './loginReducer';
import * as noticeboardReducer from './noticeboardReducer';
import * as homeworkReducer from './homeworkReducer';
import * as regularExamReducer from './regularExamReducer';
import * as digitalClassReducer from './digitalClassReducer';
import * as classMaterialReducer from './classMaterialReducer';
import * as downloadReducer from './downloadReducer';
import * as batchClassReducer from './batchClassReducer';
import * as digitalDoubtReducer from './digitalDoubtReducer';
import * as snackbarReducer from './snackbarReducer';
import * as raceAndExerciseReducer from './raceAndExerciseReducer';
import * as digitalLiveClassReducer from './digitalLiveClassReducer';
import * as dashboardReducer from './dashboardReducer';
import * as digitaDiscussionReducer from './digitalDiscussionReducer';
import * as cbseClassReducer from './cbseClassReducer';
import * as liveClassRecordingsReducer from './liveClassRecordingsReducer';
import * as homepageReducer from './homepageReducer';
import * as teacherDoubtModReducer from './teacherDoubtModReducer';
import * as performanceRecordReducer from './performanceRecordReducer';
import * as performanceAnalysisReducer from './performanceAnalysisReducer';
import * as WelcomeScreenReducer from './welcomeScreenReducer';
import * as videoPlayerReducer from './videoPlayerReducer';
import * as liveWebinarReducer from './liveWebinarReducer';
import * as textMsgReducer from './textMsgReducer';
import * as examHallReducer from './examHallReducer';
import * as liveDoubtClassReducer from './liveDoubtClassReducer';
import * as groupNotificationReducer from './groupNotificationReducer';

export default Object.assign(
  loginReducer,
  loadingReducer,
  noticeboardReducer,
  homeworkReducer,
  regularExamReducer,
  digitalClassReducer,
  classMaterialReducer,
  downloadReducer,
  batchClassReducer,
  digitalDoubtReducer,
  snackbarReducer,
  raceAndExerciseReducer,
  digitalLiveClassReducer,
  dashboardReducer,
  digitaDiscussionReducer,
  cbseClassReducer,
  liveClassRecordingsReducer,
  homepageReducer,
  teacherDoubtModReducer,
  performanceRecordReducer,
  performanceAnalysisReducer,
  WelcomeScreenReducer,
  videoPlayerReducer,
  liveWebinarReducer,
  textMsgReducer,
  examHallReducer,
  liveDoubtClassReducer,
  groupNotificationReducer
);
